import { render, staticRenderFns } from "./AlfaButtonGroup.vue?vue&type=template&id=9f8ca59c&"
import script from "./AlfaButtonGroup.vue?vue&type=script&lang=js&"
export * from "./AlfaButtonGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports